/**
 * RDB 4.3 — share control on the recipe page.
 *
 * Uses the phone's own share sheet when the browser has one (navigator.share,
 * which needs a user gesture, https and a mobile-capable browser) and falls
 * back to copying the link. Every string it says comes from data attributes
 * rendered by sections/main-recipe.liquid, so a translated store gets
 * translated messages, and the shared URL is the product's canonical URL
 * rather than the current location (which carries the preview theme id when
 * the page is being looked at on a preview).
 *
 * No request is made, nothing runs at load beyond adding one listener, and
 * without JavaScript the button does nothing (there is no href to fall back
 * to, since what it does is inherently scripted).
 */
(function () {
  'use strict';

  var button = document.querySelector('[data-recipe-share]');
  if (!button) return;

  var status = document.querySelector('[data-recipe-share-status]');
  var timer = null;

  function say(message) {
    if (!status) return;
    if (timer) {
      window.clearTimeout(timer);
      timer = null;
    }
    status.textContent = message;
    timer = window.setTimeout(function () {
      status.textContent = '';
      timer = null;
    }, 5000);
  }

  function sharedUrl() {
    return button.getAttribute('data-share-url') || window.location.href;
  }

  /* Clipboard API first; the textarea trick is the fallback for browsers that
     only expose document.execCommand (older Safari, non-secure contexts). */
  function copyText(value) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(value).then(function () {
        return true;
      }, function () {
        return legacyCopy(value);
      });
    }
    return Promise.resolve(legacyCopy(value));
  }

  function legacyCopy(value) {
    var field = document.createElement('textarea');
    field.value = value;
    field.setAttribute('readonly', 'readonly');
    field.style.position = 'fixed';
    field.style.top = '-1000px';
    field.style.opacity = '0';
    document.body.appendChild(field);
    field.select();
    var ok = false;
    try {
      ok = document.execCommand('copy');
    } catch (error) {
      ok = false;
    }
    document.body.removeChild(field);
    return ok;
  }

  button.addEventListener('click', function () {
    var url = sharedUrl();
    var title = button.getAttribute('data-share-title') || document.title;
    var text = button.getAttribute('data-share-text') || '';

    if (navigator.share) {
      navigator
        .share({ title: title, text: text, url: url })
        .catch(function (error) {
          /* A cancelled share is not a failure: say nothing, and do not fall
             through to copying, which would surprise the shopper. */
          if (error && error.name === 'AbortError') return;
          copyText(url).then(function (ok) {
            say(ok ? button.getAttribute('data-share-copied') : button.getAttribute('data-share-failed'));
          });
        });
      return;
    }

    copyText(url).then(function (ok) {
      say(ok ? button.getAttribute('data-share-copied') : button.getAttribute('data-share-failed'));
    });
  });
})();
